// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export var strIKey = "iKey";
export var strExtensionConfig = "extensionConfig";
//# sourceMappingURL=Constants.js.map